import katalReady from "@amzn/katal-components-ready";
import { KatSpinner } from "@amzn/katal-react";
import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./components/App";
import { AppInitWrapper } from "./components/AppInitWrapper";
import "./i18n";
import "./logger";

import { whenDOMContentLoaded } from "./whenDOMContentLoaded";

katalReady(() => {
  whenDOMContentLoaded(() => {
    const container = document.getElementById("root")!;
    const root = createRoot(container);
    root.render(
      <AppInitWrapper>
        <Suspense fallback={<KatSpinner size="large" />}>
          <App />
        </Suspense>
      </AppInitWrapper>
    );
  });
});
